<template>
  <div class="image-ad-container">
    <div
      v-if="type === '1'"
      :style="{ marginLeft: margin + 'px', marginRight: margin + 'px' }"
    >
      <el-carousel trigger="click" :height="imgHeight + 'px'">
        <el-carousel-item
          v-for="(v, i) in imgList"
          :key="i"
          @click="toUrl(v.url)"
        >
          <div class="img-ad-wrapper">
            <img
              class="img"
              :src="v.src"
              ref="image"
              alt="图片广告"
              @load="imageLoad"
              :class="{ radius: borderRadius }"
            />
            <span class="text" v-show="v.text">{{ v.text }}</span>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <ul class="img-list" v-if="type === '2'">
      <li
        class="list-item"
        v-for="(v, i) in imgList"
        :key="i"
        @click="toUrl(v.url)"
        :style="{
          marginLeft: margin + 'px',
          marginRight: margin + 'px',
          marginBottom: marginBottom + 'px'
        }"
      >
        <img
          class="img"
          :src="v.src"
          alt="图片广告"
          :class="{ radius: borderRadius }"
        />
        <span v-show="v.text" class="text">{{ v.text }}</span>
      </li>
    </ul>
    <div
      v-if="type === '3'"
      class="flex flex-between"
      :style="{ marginLeft: margin + 'px', marginRight: margin + 'px' }"
    >
      <div class="flex-1" v-if="leftImgList.length">
        <el-carousel
          trigger="click"
          :height="imgHeight + 'px'"
          :interval="4000"
        >
          <el-carousel-item
            v-for="(v, i) in leftImgList"
            :key="i"
            @click="toUrl(v.url)"
          >
            <div class="img-ad-wrapper">
              <img
                class="img"
                @load="imageLoad"
                ref="image"
                :src="v.src"
                alt="图片广告"
                :class="{ radius: borderRadius }"
              />
              <span class="text" v-show="v.text">{{ v.text }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="flex-1" v-if="rightImgList.length">
        <el-carousel
          trigger="click"
          :height="imgHeight + 'px'"
          class="flex-1"
          :interval="5000"
        >
          <el-carousel-item
            v-for="(v, i) in rightImgList"
            :key="i"
            @click="toUrl(v.url)"
          >
            <div class="img-ad-wrapper">
              <img
                class="img"
                @load="imageLoad"
                :src="v.src"
                ref="image"
                alt="图片广告"
                :class="{ radius: borderRadius }"
              />
              <span class="text" v-show="v.text">{{ v.text }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "1"
    },
    isSwiper: {
      type: Boolean,
      default: false
    },
    leftImgList: {
      type: Array,
      default: () => {}
    },
    rightImgList: {
      type: Array,
      default: () => {}
    },
    imgList: {
      type: Array,
      default: () => {}
    },
    borderRadius: {
      type: Boolean,
      default: false
    },
    margin: {
      type: Number,
      default: 0
    },
    marginBottom: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      imgHeight: 0
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    imageLoad() {
      this.$nextTick(() => {
        this.imgHeight = this.$refs.image[0].height;
      });
    },
    toUrl() {}
  }
};
</script>
<style lang="scss" scoped>
.image-ad-container {
  .img-ad-wrapper {
    position: relative;
  }

  .img {
    width: 100%;
    font-size: 0;
  }
  .text {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background-color: rgba(51, 51, 51, 0.8);
    color: #fff;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
  }

  .img-list {
    .list-item {
      position: relative;
      font-size: 0;
    }

    .radius {
      border-radius: 10px;
    }
  }
}
</style>
